export default defineNuxtPlugin(() => {
  const anonymousStore = useAnonymousStore()
  anonymousStore.ensureAnonymousId()
})
